// Global imports
import { clsx } from 'clsx'

// Types
import type { ReactNode } from 'react'

type NoticeVariant = 'success' | 'warning' | 'error' | 'info'

interface NoticeProps {
  variant?: NoticeVariant
  title?: string
  children: ReactNode
  className?: string
  titleClassName?: string
}

const variantClasses: Record<NoticeVariant, { wrapper: string }> = {
  success: { wrapper: 'border-green-200 bg-green-50 text-green-950' },
  warning: { wrapper: 'border-yellow-400 bg-yellow-50 text-yellow-950' },
  error: { wrapper: 'border-red-200 bg-red-50 text-red-950' },
  info: { wrapper: 'border-blue-200 bg-blue-50 text-blue-950' },
}

const Notice = ({
  variant = 'info',
  title,
  children,
  className,
  titleClassName,
}: NoticeProps) => {
  return (
    <div
      className={clsx(
        'rounded-2xl border p-4 text-sm',
        variantClasses[variant].wrapper,
        className
      )}
      role={variant === 'error' ? 'alert' : 'status'}
      aria-live={variant === 'error' ? 'assertive' : 'polite'}
    >
      {title ? (
        <p className={clsx('mb-2 text-base font-bold', titleClassName)}>
          {title}
        </p>
      ) : null}
      <div>{children}</div>
    </div>
  )
}

export default Notice
export type { NoticeVariant, NoticeProps }
